
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/web-development",
      function () {
        return require("private-next-pages/services/web-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/web-development"])
      });
    }
  